import { Sparkles } from "lucide-react";

/**
 * SponsorDemoStrip — pitch-ready overlay reserved for VerseSport sponsorship
 * activation. No third-party brands surfaced. Mounted on /showcase when
 * ?mode=sponsor is present.
 */
const SLOTS = [
  { key: "nation-wars", title: "Nation Wars · Picos de rivalidad", region: "LATAM" },
  { key: "creator-takeover", title: "Ondas de comunidad · Takeover de creadores", region: "GLOBAL" },
  { key: "halftime", title: "Quinielas de medio tiempo · Explosión de pronósticos", region: "AMÉRICA" },
  { key: "goal-pressure", title: "Presión de gol · Drama final", region: "GLOBAL" },
  { key: "trending", title: "Momentos tendencia · CTAs cinematográficos", region: "GLOBAL" },
];

export function SponsorDemoStrip() {
  return (
    <aside
      aria-label="Sponsor activation slots"
      className="rounded-2xl border border-border/60 bg-background/95 p-3"
    >
      <header className="flex items-center gap-1.5 text-[12px] font-black uppercase tracking-widest text-foreground">
        <Sparkles className="h-3.5 w-3.5 text-primary" aria-hidden /> Patrocinio Disponible · Powered by VerseSport Intelligence
      </header>
      <ul className="mt-2 grid gap-1.5 sm:grid-cols-3">
        {SLOTS.map((s) => (
          <li
            key={s.key}
            className="rounded-lg border border-dashed border-primary/40 bg-background/95 px-2 py-1.5"
          >
            <div className="text-[12px] font-black text-foreground">
              {s.title} <span className="text-foreground/70 font-bold">· {s.region}</span>
            </div>
            <div className="text-[11px] font-semibold text-foreground/80">Slot abierto · contacto comercial</div>
          </li>
        ))}
      </ul>
      <p className="mt-2 text-[11px] font-medium text-foreground/80">
        Métricas de impacto canalizadas a War Room · Admin → Operations.
      </p>
    </aside>
  );
}